import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { Subject } from 'rxjs';
import { SystemStatusSocketCommands } from 'ops/common/io-event/websocket-message';
import { FcuStatusObject } from '@models/system-status';

@Injectable({ providedIn: 'root' })
export class SystemStatusSocketService {
    private updateSystemStatus$: Subject<FcuStatusObject> = new Subject<FcuStatusObject>();
    private updateConnectionStatus$: Subject<boolean> = new Subject<boolean>();

    private isReceivingData: boolean = true;

    constructor(private socketService: SocketMiddlewareService) {
        this.systemStatusUpdated();
        this.systemStatusConnected();
        this.systemStatusDisconnected();
    }

    updateStatusSubject(): Subject<any> {
        return this.updateSystemStatus$;
    }

    updateConnectionSubject(): Subject<boolean> {
        return this.updateConnectionStatus$;
    }

    systemStatusUpdated() {
        return this.socketService
            .receiveMessageObserver(SystemStatusSocketCommands.STATUS_UPDATED)
            .subscribe((systemStatus) => this.updateSystemStatus$.next(systemStatus));
    }

    systemStatusConnected() {
        return this.socketService
            .receiveMessageObserver(SystemStatusSocketCommands.STATUS_CONNECTED)
            .subscribe(() => {
                this.isReceivingData = true;
                this.updateConnectionStatus$.next(true);
            });
    }

    systemStatusDisconnected() {
        return this.socketService
            .receiveMessageObserver(SystemStatusSocketCommands.STATUS_DISCONNECTED)
            .subscribe(() => {
                this.isReceivingData = false;
                this.updateConnectionStatus$.next(false);
            });
    }

    getIsReceivingData() {
        return this.isReceivingData;
    }
}
